import { ClickOutsideController } from 'stimulus-use'

export default class extends ClickOutsideController {
    static targets = ['toggleElement']
    static values = {
        toggleClass: { type: String, default: 'toggled' },
        removeOutside: Boolean
    }

    toggle() {
        this._getElement().classList.toggle(this.toggleClassValue);
    }

    add() {
        this._getElement().classList.add(this.toggleClassValue);
    }

    remove() {
        this._getElement().classList.remove(this.toggleClassValue);
    }

    _getElement() {
        if (this.hasToggleElementTarget) {
            return this.toggleElementTarget;
        }

        return this.element;
    }

    clickOutside() {
        if (this.removeOutsideValue) {
            this.remove();
        }
    }
}
